export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-squidoo-fc52a10f42293bc0d3a30abcb7c93dcd.svg";